/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Action } from '@ngrx/store';
import {
  UpdateValuationDateRequest,
  ValuationDate,
  ValuationDateStatus
} from 'app/page-modules/tenant-management/modules/valuation-dates/models';
import { DateTime } from 'luxon';

// -------------------------------------------------------------------------
// Clear state
export const CLEAR_STATE = '[Valuation Dates] Clear State';

// -------------------------------------------------------------------------
// Load tenant valuation dates
export const LOAD_VALUATION_DATES = '[Valuation Dates] Load Tenant Valuation Dates';
export const LOAD_VALUATION_DATES_SUCCESS = '[Valuation Dates] Load Tenant Valuation Dates Success';
export const LOAD_VALUATION_DATES_ERROR = '[Valuation Dates] Load Tenant Valuation Dates Error';

// -------------------------------------------------------------------------
// Select tenant valuation date
export const SELECT_VALUATION_DATE = '[Valuation Dates] Select Tenant Valuation Date';

// -------------------------------------------------------------------------
// Update tenant selected valuation date
export const UPDATE_SELECTED_VALUATION_DATE =
  '[Valuation Dates] Update Tenant Selected Valuation Date';

// -------------------------------------------------------------------------
// Save tenant valuation date
export const SAVE_VALUATION_DATE = '[Valuation Dates] Save Tenant Valuation Date';
export const SAVE_VALUATION_DATE_SUCCESS = '[Valuation Dates] Save Tenant Valuation Date Success';
export const SAVE_VALUATION_DATE_ERROR = '[Valuation Dates] Save Tenant Valuation Date Error';

// -------------------------------------------------------------------------
// Clear state
export class ClearState implements Action {
  readonly type = CLEAR_STATE;
}

// -------------------------------------------------------------------------
// Load tenant valuation dates
export class LoadValuationDates implements Action {
  readonly type = LOAD_VALUATION_DATES;
}

export class LoadValuationDatesSuccess implements Action {
  readonly type = LOAD_VALUATION_DATES_SUCCESS;

  constructor(public valuationDates: ValuationDate[]) {}
}

export class LoadValuationDatesError implements Action {
  readonly type = LOAD_VALUATION_DATES_ERROR;

  constructor(public errorMessage: string) {}
}

// -------------------------------------------------------------------------
// Select tenant valuation date
export class SelectValuationDate implements Action {
  readonly type = SELECT_VALUATION_DATE;

  constructor(public valuationDate: DateTime | undefined) {}
}

// -------------------------------------------------------------------------
// Update selected tenant valuation date
export class UpdateSelectedValuationDate implements Action {
  readonly type = UPDATE_SELECTED_VALUATION_DATE;

  constructor(public status: ValuationDateStatus) {}
}

// -------------------------------------------------------------------------
// Save tenant valuation date
export class SaveValuationDate implements Action {
  readonly type = SAVE_VALUATION_DATE;

  constructor(public valuationDate: DateTime, public request: UpdateValuationDateRequest) {}
}

export class SaveValuationDateSuccess implements Action {
  readonly type = SAVE_VALUATION_DATE_SUCCESS;

  constructor(public valuationDate: DateTime) {}
}

export class SaveValuationDateError implements Action {
  readonly type = SAVE_VALUATION_DATE_ERROR;

  constructor(public valuationDate: DateTime, public errorMessage: string) {}
}

// -------------------------------------------------------------------------
export type All =
  | ClearState
  | LoadValuationDates
  | LoadValuationDatesSuccess
  | LoadValuationDatesError
  | SelectValuationDate
  | UpdateSelectedValuationDate
  | SaveValuationDate
  | SaveValuationDateSuccess
  | SaveValuationDateError;
